import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { ILoyaltyExchange } from "../../models/Loyalty";
import { LoyaltyService } from "../../services/loyalty.service";

export const useGetLoyaltyExchangesQuery = () => {
  return useQuery<ILoyaltyExchange[], Error>({
    queryKey: [QUERY_CONSTANTS.GET_LOYALTY_EXCHANGES],
    queryFn: () => LoyaltyService.getLoyaltyExchanges().then((res) => res.data),
  });
};
